import { createRestAPIModelGenerator } from 'src/data/models/generator';
export const TYPE = 'new-zealand-regions';

const NewZealandRegionsGenerator = createRestAPIModelGenerator(TYPE);
export default NewZealandRegionsGenerator.createValueListModel();
